import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import coverImg from '../../utils/cover-img.jpg';
import '../cart/cart.css';
import './favorite.css';
import EmptyCart from '../../utils/zero-state-screens/Empty_Cart.svg';
import { useNavigate, Link } from 'react-router-dom';
import { BsPlus } from "react-icons/bs";
import { BiMinus } from 'react-icons/bi';
import api from '../../api/api';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
import { RiDeleteBinLine } from 'react-icons/ri';
import { IoIosArrowDown } from 'react-icons/io';
import { ActionTypes } from '../../model/action-type';
import Loader from '../loader/Loader';
import { useTranslation } from 'react-i18next';
import { setProductSizes } from '../../model/reducer/productSizesReducer';
import { setFavourite, setFavouriteLength, setFavouriteProductIds } from '../../model/reducer/favouriteReducer';
import { setCart, setCartProducts, setCartSubTotal, setSellerFlag } from '../../model/reducer/cartReducer';
import QuickViewModal from '../product/QuickViewModal';
import Popup from '../same-seller-popup/Popup';
import { Button, Spin } from 'antd';

const Wishlist = () => {
    const closeCanvas = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cookies = new Cookies();

    const favorite = useSelector(state => state.favourite);
    const city = useSelector(state => state.city);
    const sizes = useSelector(state => state.productSizes);
    const cart = useSelector(state => state.cart);
    const setting = useSelector(state => state.setting);
    const user = useSelector(state => state.user);

    const [productSizes, setproductSizes] = useState(null);
    const [isfavoriteEmpty, setisfavoriteEmpty] = useState(false);
    const [isLoader, setisLoader] = useState(false);
    const [selectedProduct, setselectedProduct] = useState({});
    const [p_id, setP_id] = useState(0);
    const [p_v_id, setP_V_id] = useState(0);
    const [qnty, setQnty] = useState(0);

    useEffect(() => {
        if (sizes.sizes === null || sizes.status === 'loading') {
            if (city.city !== null && favorite.favorite !== null) {
                api.getProductbyFilter(city.city.latitude, city.city.longitude)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === 1) {
                            setproductSizes(result.sizes);
                            dispatch(setProductSizes({ data: result.sizes }));
                        }
                    });
            }
        } else {
            setproductSizes(sizes.sizes);
        }

        if (favorite.favorite === null && favorite.status === 'fulfill') {
            setisfavoriteEmpty(true);
        } else {
            setisfavoriteEmpty(false);
        }

    }, [favorite]);

    useEffect(() => {
        api.getFavorite(localStorage.getItem('jwt_token'), city.city.latitude, city.city.longitude)
            .then(response => response.json())
            .then((result) => {
               
                dispatch(setFavourite({ data: result }));
            });
    }, []);

    const truncateTitle = (title) => {
        const words = title.split(' ');
        return words.length > 5 ? words.slice(0, 4).join(' ') + '...' : title;
    };

    // Add to Cart
    const addtoCart = async (product_id, product_variant_id, qty) => {
        if (!user?.user) {
            document.getElementById("user-profile").click();
            return;
        }
        await api.addToCart(localStorage.getItem('jwt_token'), product_id, product_variant_id, qty)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                    if (cart?.cartProducts?.find((product) => (product?.product_id == product_id) && (product?.product_variant_id == product_variant_id))?.qty == undefined) {
                        dispatch(setCart({ data: result }));
                        dispatch(setCartSubTotal({ data: result?.data?.sub_total }));
                        const updatedCartCount = [...cart?.cartProducts, { product_id: product_id, product_variant_id: product_variant_id, qty: qty }];
                        dispatch(setCartProducts({ data: updatedCartCount }));
                    } else {
                        const updatedProducts = cart?.cartProducts?.map(product => {
                            if ((product.product_id == product_id) && (product?.product_variant_id == product_variant_id)) {
                                return { ...product, qty: qty };
                            } else {
                                return product;
                            }
                        });
                        dispatch(setCart({ data: result }));
                        dispatch(setCartProducts({ data: updatedProducts }));
                        dispatch(setCartSubTotal({ data: result?.data?.sub_total }));
                    }
                } else if (result?.data?.one_seller_error_code == 1) {
                    dispatch(setSellerFlag({ data: 1 }));
                } else {
                    toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                }
            });
    };

    // Remove from Cart
    const removefromCart = async (product_id, product_variant_id) => {
        setisLoader(true);
        await api.removeFromCart(localStorage.getItem('jwt_token'), product_id, product_variant_id)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                    dispatch(setCartSubTotal({ data: result?.sub_total }));
                    const updatedCartProducts = cart?.cartProducts?.filter(product => {
                        if (product?.product_variant_id != product_variant_id) {
                            return product;
                        }
                    });
                    dispatch(setCartProducts({ data: updatedCartProducts ? updatedCartProducts : [] }));
                    setisLoader(false);
                } else {
                    setisLoader(false);
                    toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                }
            })
            .catch(error => console.log(error));
    };

    // Remove from Favorite
    const removefromFavorite = async (product_id) => {
        setisLoader(true);
        await api.removeFromFavorite(localStorage.getItem('jwt_token'), product_id)
            .then(response => response.json())
            .then(async (result) => {
                if (result.status === 1) {
                    toast.success(result.message, { hideProgressBar: true, autoClose: 1000 });
                    await api.getFavorite(localStorage.getItem("jwt_token"), city?.city?.latitude, city?.city?.longitude)
                        .then((res) => res.json())
                        .then((result) => {
                            dispatch(setFavourite({ data: result }));
                        });
                    const updatedFavouriteProducts = favorite?.favouriteProductIds.filter(id => id !== product_id);
                    dispatch(setFavouriteProductIds({ data: updatedFavouriteProducts }));
                    const updatedFavouriteLength = favorite?.favouritelength - 1;
                    dispatch(setFavouriteLength({ data: updatedFavouriteLength }));
                    setisLoader(false);
                } else {
                    setisLoader(false);
                    toast.error(result.message, { hideProgressBar: true, autoClose: 1000 });
                }
            });
    };

    const getCartQuantity = (product) => {
        return cart?.cartProducts?.find(prdct => prdct?.product_variant_id === product?.variants[0]?.id)?.qty || 0;
    };

    // Handle quantity changes for adding/removing from cart
    const handleQuantityChange = async (product, change) => {
        const currentQty = getCartQuantity(product);
        const newQty = currentQty + change;

        if (newQty <= 0) {
            removefromCart(product.id, product.variants[0]?.id);
        } else {
            addtoCart(product.id, product.variants[0]?.id, newQty);
        }
    };

    const { t } = useTranslation();

    const placeHolderImage = (e) => {
        e.target.src = setting.setting?.web_logo;
    };

    return (
        <section id='wishlist' className='wishlist topMargin'>
            <div className='cover'>
                <img src={coverImg} className='img-fluid' alt="cover" />
                <div className='title'>
                    <h3>{t("wishList")}</h3>
                    <span><Link to='/' className='text-light text-decoration-none'>{t("home")} / </Link></span>
                    <span className=''>{t("wishList")}</span>
                </div>
            </div>

            <div className='view-cart-container container'>
                {favorite.favorite && favorite.favorite.status === 0 ? (
                    <div className='empty-cart'>
                        <img src={EmptyCart} className='no-data-img' alt='empty-cart' />
                        <p>{t("enter_wishlist_message")}</p>
                        <span>{t("enter_wishlist_description")}</span>
                        <Button type='primary' onClick={() => navigate('/products')}>{t("empty_cart_list_button_name")}</Button>
                    </div>
                ) : (
                    <>
                        {favorite.favorite === null || productSizes === null ? (
                            <Spin size="large" />
                        ) : (
                            <>
                                {/* {isLoader ? <Loader screen='full' background='none' /> : null} */}
                                <div className='viewcart-product-wrapper'>
                                    <div className='product-heading'>
                                        <h3>{t("My Wishlist")}</h3>
                                        <span>{t("there_are")} </span>
                                        <span className='title'>{favorite.favorite.total}</span>
                                        <span> {t("product_in_your_saved")}</span>
                                    </div>
                                    <div className='wishlist-cards'>
                                        {favorite.favorite?.data.map((product) => (
                                            <div className='wishlist-card' key={product.id}>
                                                <div className='product-image'>
                                                    <img onError={placeHolderImage} src={product.image_url} alt='product' />
                                                </div>

                                                <div className='wishlist-card-content'>
                                                    <h4 className='product-title' title={product.name}>{truncateTitle(product.name)}</h4>

                                                    <div className='price'>
                                                        <span className='price'>{`${setting.setting?.currency} ${product.variants[0]?.discounted_price !== "0" ? product.variants[0]?.discounted_price : product.variants[0]?.price}`}</span>
                                                    </div>
                                                    <div className='quantity-control'>
                                                        {getCartQuantity(product) > 0 ? (
                                                            <div className='counter'>
                                                                <button type='button' onClick={() => handleQuantityChange(product, -1)}><BiMinus fill='#fff' /></button>
                                                                <span>{getCartQuantity(product)}</span>
                                                                <button type='button' onClick={() => handleQuantityChange(product, 1)}><BsPlus fill='#fff' /></button>
                                                            </div>
                                                        ) : (
                                                            <button type='button' className='add-to-cart' onClick={() => addtoCart(product.id, product.variants[0]?.id, 1)}>
                                                                {t("add_to_cart")}
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className='action-buttons'>
                                                        <Button type="text" onClick={() => removefromFavorite(product.id)}>
                                                            <RiDeleteBinLine fill="red" fontSize="2.985rem" />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            <QuickViewModal selectedProduct={selectedProduct} setselectedProduct={setselectedProduct} />
            <Popup
                product_id={p_id}
                product_variant_id={p_v_id}
                quantity={qnty}
                setisLoader={setisLoader}
                cookies={cookies}
                toast={toast}
                city={city}
                setP_V_id={setP_V_id}
                setP_id={setP_id} />
        </section>
    );
};

export default Wishlist;